<template>
  <nav class="navbar-light bg-white">
    <div class="container">
      <div class="row">
        <div class="col-md-3">
          <a class="navbar-brand" href="#">
            <img src="../assets/bicm.png" alt="" width="200px" />
          </a>
        </div>
        <div class="col-md-7 p-4 text-center">
          <h5>Bangladesh Institute of Capital Market (BICM)</h5>
          <h5>বাংলাদেশ ইন্সটিটিউট অব ক্যাপিটাল মার্কেট (বিআইসিএম)</h5>

          <h3 class="">Digital Financial Literacy Project</h3>
        </div>
        <div class="col-md-2"></div>
        <hr />
      </div>
    </div>
  </nav>
</template>

<script>
export default {};
</script>

<style></style>
